import { render } from "./quick_view_settings.vue?vue&type=template&id=0a19a45c"
import script from "./quick_view_settings.js?vue&type=script&lang=js"
export * from "./quick_view_settings.js?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__